import { ContentIcon } from '../ContentIcon';

import {
  Icon,
  Icons,
  Size,
  TextIconColor,
  ToolTip,
  Typography,
  TypographySize
} from '~/components/core';
import { withLink } from '~/components/core/hocs';
import { TypographyWrap } from '~/components/core/Typography';
import { getContentFetchUrl } from '~/constants';
import { ContentSource } from '~/types';
import { TailwindMaxWidthClass } from '~/utils/tailwind.types';
import { cn } from '~/utils/tailwind.utils';

interface ContentReferenceProps {
  contentId: string;
  fileName: string;
  source: ContentSource;
  canDownload?: boolean;
  nameMaxWidth?: TailwindMaxWidthClass;
  onClick?: () => void;
  showRemoveIcon?: boolean;
  tooltip?: string | undefined;
  url?: string;
}

const ContentReference = ({
  contentId,
  fileName,
  source,
  canDownload = false,
  url,
  nameMaxWidth,
  onClick,
  showRemoveIcon,
  tooltip
}: ContentReferenceProps) => {
  const isClickable = !!onClick || canDownload || !!url;

  return (
    <ToolTip content={tooltip}>
      {withLink(
        // TODO: Dedupe with Button, need a way to handle non-clickable ones though
        <div
          className={cn(
            'flex cursor-default items-center justify-between gap-4 rounded py-2',
            showRemoveIcon ? 'px-3' : 'pl-3 pr-4',
            isClickable &&
              'bg-white/10 transition-colors duration-200 hover:bg-white/20'
          )}
          data-testid="content-reference-container"
          onClick={onClick}
        >
          <div className="flex gap-1">
            <ContentIcon contentSource={source} size={Size.MEDIUM} />
            {/* Not all file names are encoded, but decode just in case */}
            <Typography
              color={TextIconColor.PRIMARY}
              maxWidth={nameMaxWidth}
              size={TypographySize.X_SMALL}
              wrap={
                nameMaxWidth ? TypographyWrap.NO_WRAP : TypographyWrap.NORMAL
              }
            >
              {decodeURIComponent(fileName)}
            </Typography>
          </div>
          {showRemoveIcon && (
            <div
              className="flex rounded-sm bg-white/30"
              data-testid="content-reference-close-icon"
            >
              <Icons
                color={TextIconColor.PRIMARY}
                icon={Icon.CLOSE}
                size={Size.MEDIUM}
              />
            </div>
          )}
        </div>,
        {
          href: canDownload
            ? getContentFetchUrl({
                contentId,
                isDownload: true,
                isPlaintext: false
              })
            : url,
          disabled: !canDownload && !url,
          newTab: true
        }
      )}
    </ToolTip>
  );
};

export default ContentReference;
